module.exports = __webpack_public_path__ + "images/emoji/tiger2.10df818f06c87797a862.png";